import React, { useEffect } from "react";
import { StakesCard, StakesContainer } from "./Stakes.styled";
import { getStakes } from "../../feature/stake/StakeActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Stakes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { stakes } = useSelector((state) => state.stake);

  useEffect(() => {
    Object.keys(user).length && dispatch(getStakes({ user: user }));
  }, [dispatch, user]);

  return (
    <StakesContainer>
      {stakes &&
        stakes.map((data, index) => (
          <StakesCard key={index}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div>
                <div style={{ marginBottom: "5px" }}>
                  {data.stake_plan_set.staking_duration} Days Staking
                </div>
              </div>
              <div>
                <div>Days Running:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {Math.floor(
                    (new Date().getTime() -
                      new Date(data.date_created).getTime()) /
                      (1000 * 3600 * 24)
                  )}{" "}
                  Day
                  {Math.floor(
                    (new Date().getTime() -
                      new Date(data.date_created).getTime()) /
                      (1000 * 3600 * 24)
                  ) > 0 && "s"}{" "}
                  {data.is_completed && "(completed)"}
                </div>
              </div>
              <div>
                <div>Earnings In Days:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {(
                    (data.return_on_stake /
                      data.stake_plan_set.staking_duration) *
                    Math.floor(
                      (new Date().getTime() -
                        new Date(data.date_created).getTime()) /
                        (1000 * 3600 * 24)
                    )
                  ).toFixed(2)}{" "}
                  TRX
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>Total:</div>
                <div style={{ color: "#C597F8", marginInlineStart: "5px" }}>
                  {(
                    (data.amount * parseInt(data.stake_plan_set.percentage)) /
                      100 +
                    parseInt(data.amount)
                  ).toFixed(2)}{" "}
                  TRX
                </div>
              </div>
            </div>

            {
              !data.is_completed && (
                <button
                  style={{ width: "30%", height: "40px", marginBlock: "auto" }}
                  onClick={() =>
                    navigate("/withdraw-stake", { state: { data } })
                  }
                >
                  Withdraw
                </button>
              )
              // : (
              //   <button
              //     style={{ width: "30%", height: "40px", marginBlock: "auto" }}
              //     onClick={() =>
              //       navigate("/withdraw-stake", { state: { data } })
              //     }
              //   >
              //     Break
              //   </button>
              // )
            }
          </StakesCard>
        ))}
    </StakesContainer>
  );
};

export default Stakes;
